import { render, staticRenderFns } from "./equity-widget.vue?vue&type=template&id=1c2d6c66&"
import script from "./equity-widget.vue?vue&type=script&lang=js&"
export * from "./equity-widget.vue?vue&type=script&lang=js&"
import style0 from "./equity-widget.vue?vue&type=style&index=0&id=1c2d6c66&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports